/**
 * 招聘岗位列表页（使用 Redux 管理状态）
 * 未使用
 */
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import CityDropdowns from "../components/CityDropdowns";
import { RecruitmentRow1 } from "../components/DataRow";
import Navbar from "../components/Navbar";
import PlayImg from "../components/PlayImg";
import {
  appendJob,
  initializeFromParams,
  resetAll,
  setBanner,
  setCategory,
  setCity,
  setEducation,
  setIndustry,
  setJob,
  setPage,
  setSalary,
} from "../recruitmentListSlice";

function Salary({ onChange, value }) {
  return (
    <input
      type="number"
      className="form-control"
      style={{ fontSize: 14 }}
      placeholder="薪资"
      defaultValue={value}
      onBlur={onChange}
    />
  );
}

Salary.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

Salary.defaultProps = {
  value: "",
};

function EducationPicker({ onChange, value }) {
  return (
    <select
      className="form-control"
      style={{ fontSize: 14 }}
      onChange={onChange}
      defaultValue={value}
    >
      <option value="">学历要求</option>
      <option>高中及以上</option>
      <option>大专及以上</option>
      <option>本科及以上</option>
      <option>硕士及以上</option>
      <option>博士</option>
    </select>
  );
}

EducationPicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

EducationPicker.defaultProps = {
  value: "",
};

function IndustryPicker({ onChange, value }) {
  const [industry, setIndustry] = React.useState([]);
  const [selected, setSelected] = React.useState(value);

  useEffect(() => {
    const fetchData = async () => {
      const uri = [
        "/crate-api-data",
        "/mysql",
        "/ovaphlow.setting?",
        "f=equal,4,category,行业,ref_id,0",
      ];
      const response = await fetch(uri.join(""));
      if (response.status < 400) {
        const data = await response.json();
        const d = data.map((item) => ({ id: item.id, name: JSON.parse(item.detail)?.name }));
        setIndustry(d);
        sessionStorage.setItem("industry", JSON.stringify(d));
      }
    };

    const sd = sessionStorage.getItem("industry");
    if (sd) {
      setIndustry(JSON.parse(sd));
    } else {
      fetchData();
    }
  }, []);

  const handleChange = (e) => {
    setSelected(e.target.value);
    onChange(e);
  };

  return (
    <select
      className="form-control"
      style={{ fontSize: 14 }}
      onChange={handleChange}
      value={selected}
    >
      <option value="">行业</option>
      {industry.map((item) => (
        <option key={item.id} value={item.name}>
          {item.name}
        </option>
      ))}
    </select>
  );
}

IndustryPicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

IndustryPicker.defaultProps = {
  value: "",
};

async function getJobList({ city, industry, education, salary, category, page = 1 }) {
  const take = 10;
  const filter = [];

  filter.push("eq", 2, "status", "在招");

  const equal = [];
  if (city) {
    equal.push("address2", city);
  }
  if (equal.length > 0) {
    filter.push("equal", equal.length, ...equal);
  }

  const like = [];
  if (industry) {
    like.push("industry", industry);
  }
  if (education) {
    like.push("education", education);
  }
  if (category) {
    like.push("category", category);
  }
  if (like.length > 0) {
    filter.push("like", like.length, ...like);
  }

  if (salary && salary > 0) {
    filter.push("less-equal", 2, "salary1", salary);
    filter.push("greater-equal", 2, "salary2", salary);
  }

  const uri = [
    "/crate-api-data",
    "/mysql",
    "/billboard.recruitment?",
    `f=${filter}`,
    `&l=order by date_refresh desc limit ${(page - 1) * take},${take}`,
  ];
  return await fetch(uri.join(""));
}

export default function ListRedux() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const state = useSelector((state) => state.recruitmentList);

  const urlParams = new URLSearchParams(location.search);
  const initialCity = urlParams.get("city") || "";
  const initialCategory = urlParams.get("category") || "";
  const initialIndustry = urlParams.get("industry") || "";
  const initialEducation = urlParams.get("education") || "";
  const initialSalary = urlParams.get("salary") || "";

  const [flag, setFlag] = useState(true);
  const [hasInitialized, setHasInitialized] = useState(false);

  const updateUrlParams = (params) => {
    const searchParams = new URLSearchParams(location.search);
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        searchParams.set(key, value);
      } else {
        searchParams.delete(key);
      }
    });
    const newSearch = searchParams.toString();
    history.replace({
      pathname: location.pathname,
      search: newSearch ? `?${newSearch}` : "",
    });
  };

  const handleClick = (el) => {
    const nextCategory = state.CATEGORY === el ? "" : el;
    dispatch(setCategory(nextCategory));
    updateUrlParams({ category: nextCategory });
  };

  const handleChange = (val) => {
    dispatch(setCity(val));
    updateUrlParams({ city: val });
  };

  const loadNextPage = () => {
    dispatch(setPage(state.PAGE + 1));
  };

  useEffect(() => {
    if (0 === state.BANNER.length) {
      fetch("/api/bulletin?option=banner-by-category&category=小程序-岗位")
        .then((response) => response.json())
        .then((data) => {
          dispatch(setBanner(data));
        });
    }
  }, []);

  useEffect(() => {
    if (hasInitialized) return;

    dispatch(
      initializeFromParams({
        city: initialCity,
        category: initialCategory,
        industry: initialIndustry,
        education: initialEducation,
        salary: initialSalary,
      }),
    );
    setHasInitialized(true);
  }, [
    initialCity,
    initialCategory,
    initialIndustry,
    initialEducation,
    initialSalary,
    dispatch,
    hasInitialized,
  ]);

  useEffect(() => {
    if (!hasInitialized) return;

    const fetchData = async () => {
      const response = await getJobList({
        city: state.CITY,
        industry: state.INDUSTRY,
        education: state.EDUCATION,
        salary: state.SALARY,
        category: state.CATEGORY,
        page: 1,
      });
      if (response.status < 400) {
        const data = await response.json();
        dispatch(setJob(data));
        dispatch(setPage(2));
        if (0 === data.length) {
          const loadEl = document.getElementById("load");
          if (loadEl) loadEl.innerHTML = "已经到底了";
        }
      }
    };
    fetchData();
  }, [
    state.CITY,
    state.CATEGORY,
    state.INDUSTRY,
    state.EDUCATION,
    state.SALARY,
    hasInitialized,
    dispatch,
  ]);

  useEffect(() => {
    if (!hasInitialized || state.PAGE < 2) return;

    const fetchData = async () => {
      setFlag(false);
      const response = await getJobList({
        city: state.CITY,
        industry: state.INDUSTRY,
        education: state.EDUCATION,
        salary: state.SALARY,
        category: state.CATEGORY,
        page: state.PAGE,
      });
      if (response.status < 400) {
        const data = await response.json();
        dispatch(appendJob(data));
        setFlag(true);

        if (0 === data.length) {
          const loadEl = document.getElementById("load");
          if (loadEl) loadEl.innerHTML = "已经到底了";
        }
      }
    };
    fetchData();
  }, [
    state.PAGE,
    state.CITY,
    state.CATEGORY,
    state.INDUSTRY,
    state.EDUCATION,
    state.SALARY,
    hasInitialized,
    dispatch,
  ]);

  return (
    <>
      <div className="container-fluid">
        {0 < state.BANNER.length && <PlayImg category="小程序-岗位" list={state.BANNER} />}
        <div className="row pb-2 pt-2" style={{ backgroundColor: "#f5f5f5" }}>
          <div className="col">
            <input
              type="text"
              className="w-100 border-0 text-center rounded-pill"
              placeholder="按照企业/职位名称查询"
              onClick={() => {
                window.location.href = "#岗位/查询/";
              }}
              style={{ outline: 0, height: 35 }}
            />
          </div>
        </div>
        <div className="card border-0 mt-1 shadow">
          <div className="card-body">
            <div className="row mb-3" style={{ fontSize: 14 }}>
              <div className="col">
                <CityDropdowns defaultValue={initialCity} handleChange={handleChange} />
              </div>
              <div className="col flex-end">
                <div className="pull-right text-muted">
                  <span
                    className={
                      state.CATEGORY === "兼职" || state.CATEGORY === ""
                        ? "text-success bg-light"
                        : "text-muted"
                    }
                    onClick={() => handleClick("兼职")}
                  >
                    兼职
                  </span>
                  &nbsp;&nbsp;|&nbsp;&nbsp;
                  <span
                    className={
                      state.CATEGORY === "全职" || state.CATEGORY === ""
                        ? "text-success bg-light"
                        : "text-muted"
                    }
                    onClick={() => handleClick("全职")}
                  >
                    全职
                  </span>
                  &nbsp;&nbsp;|&nbsp;&nbsp;
                  <span
                    className={
                      state.CATEGORY === "实习" || state.CATEGORY === ""
                        ? "text-success bg-light"
                        : "text-muted"
                    }
                    onClick={() => handleClick("实习")}
                  >
                    实习
                  </span>
                  &nbsp;&nbsp;|&nbsp;&nbsp;
                  <span
                    className={state.CATEGORY === "" ? "text-success bg-light" : "text-muted"}
                    onClick={() => handleClick("")}
                  >
                    全选
                  </span>
                </div>
              </div>
            </div>
            <div className="mb-3 px-4 d-flex flex-nowrap">
              <div className="flex-grow-1 px-1" style={{ minWidth: 0 }}>
                <IndustryPicker
                  value={initialIndustry}
                  onChange={(e) => {
                    dispatch(setIndustry(e.target.value));
                    updateUrlParams({ industry: e.target.value });
                  }}
                />
              </div>
              <div className="flex-grow-1 px-1" style={{ minWidth: 0 }}>
                <EducationPicker
                  value={initialEducation}
                  onChange={(e) => {
                    dispatch(setEducation(e.target.value));
                    updateUrlParams({ education: e.target.value });
                  }}
                />
              </div>
              <div className="flex-grow-1 px-1" style={{ minWidth: 0 }}>
                <Salary
                  value={initialSalary}
                  onChange={(e) => {
                    dispatch(setSalary(e.target.value));
                    updateUrlParams({ salary: e.target.value });
                  }}
                />
              </div>
            </div>
            <div>
              {0 < state.JOB.length &&
                state.JOB.map((item) => (
                  <div key={item.id}>
                    <RecruitmentRow1
                      {...item}
                      addressLevel1={item.address1}
                      addressLevel2={item.address2}
                      refreshTime={item.date_refresh}
                      id={Number(item.id)}
                      uuid={item.uuid}
                      fairId={"0"}
                    />
                    <hr style={{ marginTop: "0.5rem", marginBottom: "0.5rem" }} />
                  </div>
                ))}
            </div>
            {flag === true ? (
              <button id="load" className="btn btn-block mx-auto" onClick={loadNextPage}>
                点击加载更多
              </button>
            ) : (
              <div className="d-flex justify-content-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <button
        className="btn btn-outline-secondary rounded-circle position-fixed"
        style={{
          bottom: "70px",
          left: "20px",
          width: "45px",
          height: "45px",
          zIndex: 1000,
          padding: 0,
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        }}
        onClick={() => {
          sessionStorage.removeItem("industry");
          dispatch(resetAll());
          updateUrlParams({ city: "", category: "", industry: "", education: "", salary: "" });
          window.scrollTo({ top: 0, behavior: "instant" });
        }}
        title="重置筛选"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
          <path d="M3 3v5h5" />
        </svg>
      </button>
      <Navbar category="岗位" />
    </>
  );
}
